import {
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Grid,
  List,
  ListItemIcon,
  ListItemText,
  CircularProgress,
  LinearProgress,
  Tooltip
} from "@mui/material";
import Icon from "../../../components/icon";
import { styled } from '@mui/material/styles';
import { Fragment, useEffect, useState } from 'react';
import MuiCard from '@mui/material/Card';
import ListItem from '@mui/material/ListItem'
import IconButton from '@mui/material/IconButton'
// import ExcelCSVImport from "../../../components/ExcelCSVImport";
import CloseIcon from '@mui/icons-material/Close';
import Papa from 'papaparse'
import * as XLSX from 'xlsx'
import { ToastContainer, toast } from 'react-toastify';
import { useDropzone } from 'react-dropzone';
import { renderFilePreview } from "components/FilePrivews";
import { DownloadAttachments } from "components/logic/DownloadAttachments";
import VideoPlaceholderIcon from 'images/video_placeholder.png';
import CSV_PlaceholderIcon from 'images/Attachment_Icons/CSV__PlaceholderIcon.png';
import PDF_PlaceholderIcon from 'images/Attachment_Icons/PDF_PlaceholderIcon.png';
import DOCX_PlaceholderIcon from 'images/Attachment_Icons/DOCX__PlaceholderIcon.png';
import XLSX_PlaceholderIcon from 'images/Attachment_Icons/XLSX__PlaceholderIcon.png';
import FilePlaceholder from 'images/image_placeholder.png';


const Card = styled(MuiCard)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: { width: '100%' }
}));

const PreAttachment = ({
  open,
  handleClose,
  Title,
  files,
  setFiles,
  f,
  sf
}) => {
  const [message, setMessage] = useState('');
  const [btnLoader, setBtnLoader] = useState(false);
  const [thumbnail, setThumbnail] = useState('');
  
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage('');
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const extensionToIcon = {
    csv: CSV_PlaceholderIcon,
    pdf: PDF_PlaceholderIcon,
    doc: DOCX_PlaceholderIcon,
    xlsx: XLSX_PlaceholderIcon,
  };

  useEffect(() => {
    const fetchThumbnail = () => {
      if (files && files.length > 0) {
        const file = files[0];
        const mimeType = file.type;

        if (mimeType.startsWith('video/')) {
          setThumbnail(VideoPlaceholderIcon);
        }else if(mimeType.startsWith('image/')){
          const imgUrl = URL.createObjectURL(file);
          setThumbnail(imgUrl);
        }else if(mimeType.startsWith('text/')){
          setThumbnail(CSV_PlaceholderIcon)
        }else if(mimeType.startsWith('application/pdf')){
          setThumbnail(PDF_PlaceholderIcon)
        }else if(mimeType.startsWith('application/msword')){
          setThumbnail(DOCX_PlaceholderIcon)
        }else if(mimeType.startsWith('application/vnd')){
          setThumbnail(XLSX_PlaceholderIcon)
        }else{
          setThumbnail(FilePlaceholder);
        }
      }
    };

    if (files && files.length > 0){
      fetchThumbnail();
    }else{
      return;
    }
  }, [files]);

  const handleUpload = () => {
    const hasDuplicates = f.some(newFile => 
      files.some(existingFile => 
        existingFile.name === newFile.name
      )
    );
    
    if(hasDuplicates){
      toast.error("This file already exists please upload a different file.", {
        duration: 3000,
        position: 'top-right',
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
    }else{
      sf((prevFiles) => [...prevFiles, ...files]);
      handleClose();
    }
  }


  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'text/csv': ['.csv'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'application/pdf': ['.pdf'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
      'image/jpeg': ['.jpeg', '.jpg'],
      'image/png': ['.png'],
      'video/mp4': ['.mp4'],
    },
    onDrop: acceptedFiles => {
      setBtnLoader(true);
      setTimeout(() => {
        setFiles(acceptedFiles.map(file => Object.assign(file)));
        setBtnLoader(false);
      }, 1000);
    },
    onDropRejected: (fileRejections) => {
      setBtnLoader(false);
  
      const MAX_VIDEO_SIZE = 100 * 1024 * 1024; 
      const MAX_IMAGE_SIZE = 6 * 1024 * 1024;
      const MAX_OTHER_SIZE = 2 * 1024 * 1024;

      const tooManyFilesError = fileRejections.some(rejection => 
        rejection.errors.some(error => error.code === 'too-many-files')
      );
    
      if (tooManyFilesError) {
        toast.error("You can only upload 1 file at a time.", {
          duration: 3000,
          position: 'top-right',
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
        return; // Exit early to avoid multiple toasts
      }
  
      const errorMessages = fileRejections.map(rejection => {
        const errors = rejection.errors.map(error => {
          let customMessage = '';
          if (error.code === 'file-too-large') {
            const fileType = rejection.file.type;
            const fileName = rejection.file.name;
            const fileSizeMB = (rejection.file.size / (1024 * 1024)).toFixed(2);
  
            // Determine size limit based on file type
            if (fileType.startsWith('video/')) {
              customMessage = `File "${fileName}" is ${fileSizeMB} MB, which exceeds the 100 MB limit for videos.`;
            } else if (fileType.startsWith('image/')) {
              customMessage = `File "${fileName}" is ${fileSizeMB} MB, which exceeds the 6 MB limit for images.`;
            } else {
              customMessage = `File "${fileName}" is ${fileSizeMB} MB, which exceeds the 2 MB limit for files.`;
            }
          } else if (error.code === 'file-invalid-type') {
            customMessage = `File "${rejection.file.name}" is not an allowed type. Accepted types are CSV, XLSX, PDF, DOC, DOCX, JPEG, PNG, MP4.`;
          }
          return customMessage || error.message;
        });
  
        return errors.join(', ');
      });
  
      errorMessages.forEach(errorMessage => {
        toast.error(errorMessage, {
          duration: 3000,
          position: 'top-right',
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
      });
  
      // Optional: Set error messages to a state for further use
      // setMessage(errorMessages.join('\n'));
    },
    maxFiles: 1,
    validator: file => {
      const fileType = file.type;
      const fileSize = file.size;
  
      if (fileType.startsWith('video/') && fileSize > 100 * 1024 * 1024) {
        return {
          code: 'file-too-large',
          message: 'Video files cannot exceed 100 MB.',
        };
      } else if (fileType.startsWith('image/') && fileSize > 6 * 1024 * 1024) {
        return {
          code: 'file-too-large',
          message: 'Image files cannot exceed 6 MB.',
        };
      } else if (
        !fileType.startsWith('video/') &&
        !fileType.startsWith('image/') &&
        fileSize > 2 * 1024 * 1024
      ) {
        return {
          code: 'file-too-large',
          message: 'Files other than images or videos cannot exceed 2 MB.',
        };
      }
  
      return null;
    },
  });

  // const fileList = files.map(file => (
  //     <ListItem key={file.name} sx={{display:'flex', justifyContent:'center !important',marginTop:'5px',width: 'fit-content', boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px', borderRadius:'10px'}}>
  //       <Box className='file-details' sx={{display:'flex'}} >
  //         <Box className='file-preview' sx={{display:'flex', alignItems:'center', textAlign:'center'}}>{renderFilePreview(file)}
  //             <Box sx={{display:'flex', flexDirection:'column'}}>
  //                 <Typography className='file-name'>{file.name}</Typography>    
  //                 <Typography className='file-size' variant='body2'>
  //                     {Math.round(file.size / 100) / 10 > 1000
  //                     ? `${(Math.round(file.size / 100) / 10000).toFixed(1)} mb`
  //                     : `${(Math.round(file.size / 100) / 10).toFixed(1)} kb`}
  //                 </Typography> 
  //             </Box>                     
  //         </Box>            
  //       </Box>
  //       <IconButton onClick={() => handleRemoveFile(file)}>
  //         <Icon icon='tabler:x' fontSize={20} />
  //       </IconButton>
  //     </ListItem>
  //   ));

  const fileList = files.map(file => (
    <ListItem key={file.name} sx={{p:0}}>
      <Card sx={{ padding: '10px !important' }}>
        <CardContent sx={{ padding: '0px !important' }}>
          <Box sx={{display: 'flex', gap: 2}}>
            {/* <Box>{renderFilePreview(file.name)}</Box> */}
            <Box>
              <img
                width={50}
                height={50}
                alt={file.name || "attachment"}
                loading="lazy"
                src={thumbnail || '/images/ImageLoader.gif'}
              />
            </Box>
            <Box sx={{display: 'flex', flexDirection: 'column', width: '100%', gap: 2}}>
              <Box sx={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'}}>
                <Box>
                  <Typography className='file-name'>{file.name}</Typography>
                  <Typography className='file-size' variant='body2'>
                    {Math.round(file.size / 100) / 10 > 1000
                    ? `${(Math.round(file.size / 100) / 10000).toFixed(1)} mb`
                    : `${(Math.round(file.size / 100) / 10).toFixed(1)} kb`}
                  </Typography> 
                </Box>
                <Tooltip title='Remove File'>
                  <IconButton onClick={() => handleRemoveFile(file)}>
                    <Icon icon='tabler:x' fontSize={20} />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box sx={{display: 'flex', alignItems: 'center', gap: 4}}>
                <Box sx={{width: '100%'}}>
                  <LinearProgress value={100} variant="determinate"
                    sx={{
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: 'success.main'
                      },
                      height: '10px'
                    }}
                  />
                </Box>
                <Box color="success.main">
                  <Icon icon="tabler:circle-check-filled" />
                </Box>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </ListItem>
));

  const handleRemoveFile = (file) => {
      const filteredFiles = files?.filter(i => i.name !== file.name);
      setFiles(filteredFiles);
  };
  

  return (
      <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          PaperProps={{
              sx: {
                  maxHeight: '90vh',
                  overflow:'hidden',
              },
          }}
      >
          <DialogTitle sx={{borderBottom: '1px solid #D9D9D9', paddingBottom: '20px !important'}}>
              <Box
                  sx={{
                  display: 'flex',
                  alignItem: 'center',
                  justifyContent: 'space-between',
                  }}
              >
                  <Typography variant="h3" fontWeight='bold'>{Title}</Typography>
                  <IconButton onClick={handleClose}>
                  <Icon icon='tabler:x' />
                  </IconButton>
              </Box>
          </DialogTitle>
          {/* <DialogContent sx={{ display: "flex" }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', maxWidth: '100%', flexDirection: 'column'  , height:'fit-content', padding:'20px' }}>
                  <Grid container spacing={5}>                      
                      <Grid item xs={12}>
                          {message && (
                            <Box mb={2} textAlign="center">
                              <Typography variant="h6" color={message.includes('successfully') ? 'green' : 'red'}>
                                {message.split('\n').map((line, index) => (
                                  <div key={index}>{line}</div>
                                ))}
                              </Typography>
                            </Box>
                          )}
                          <Box sx={{ mb: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>                                
                              { customer && (
                                <Typography sx={{ color: 'text.secondary' }}>Upload Attachment For {customer?.firstName} {customer?.lastName} </Typography>
                                
                              )}
                          </Box>
                      </Grid>
                      <Grid item xs={12} sx={{ mb: 4 }}>
                          <Card sx={{ cursor: 'pointer' }}>
                              <CardContent sx={{ p: 10, flexGrow: 1, width: '100%' }}>
                                  <Fragment>
                                      <div {...getRootProps({ className: 'dropzone' })}>
                                          <input {...getInputProps()} />
                                          <Box sx={{ display: 'flex', textAlign: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                              <Box
                                                  sx={{
                                                      mb: 8.75,
                                                      width: 48,
                                                      height: 48,
                                                      display: 'flex',
                                                      borderRadius: 1,
                                                      alignItems: 'center',
                                                      justifyContent: 'center',
                                                      backgroundColor: theme => `rgba(${theme.palette.customColors.main}, 0.08)`
                                                  }}
                                              >
                                                  <Icon icon='tabler:upload' fontSize='1.75rem' />
                                              </Box>
                                              <Typography variant='h4' sx={{ mb: 2 , fontSize:'1.2rem'}}>
                                                  Choose a file or drag & drop it here.
                                              </Typography>
                                              <Typography sx={{ color: 'text.secondary', fontSize:'0.8rem' }}>Only CSV, XLSX, Images, and PDFs, up to 2 MB.</Typography>
                                          </Box>
                                      </div>
                                      {files.length ? (
                                      <Fragment>
                                          <List sx={{display:'flex', justifyContent:'center !important'}}>{fileList}</List>
                                      </Fragment>
                                      ) : null}
                                  </Fragment>
                              </CardContent>
                          </Card>
                      </Grid>                        
                  </Grid>
              </Box>
          </DialogContent> */}
          <DialogContent>
                <Grid container spacing={5} my={4}>
                    <Grid item xs={12}>
                        {message && (
                        <Box mb={2} textAlign="center">
                            <Typography variant="h6" color={message.includes('successfully') ? 'green' : 'red'}>
                            {message.split('\n').map((line, index) => (
                                <div key={index}>{line}</div>
                            ))}
                            </Typography>
                        </Box>
                        )}
                        <Box sx={{ textAlign: 'center' }}>                                
                            <Typography variant='h5'>Upload Attachment</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ cursor: 'pointer' }}>
                            <CardContent>
                                    <div {...getRootProps({ className: 'dropzone' })}>
                                        <input {...getInputProps()} />
                                        <Box sx={{ display: 'flex', textAlign: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                            <Box
                                                sx={{
                                                    mb: 6,
                                                    width: 48,
                                                    height: 48,
                                                    display: 'flex',
                                                    borderRadius: 1,
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: theme => `rgba(${theme.palette.customColors.main}, 0.08)`
                                                }}
                                            >
                                                <Icon icon='tabler:upload' fontSize='1.75rem' />
                                            </Box>
                                            <Typography variant='h4' sx={{ mb: 2 , fontSize:'1.2rem'}}>
                                                Click to Browse or Drag & Drop files here
                                            </Typography>
                                            <List>
                                            <ListItem disablePadding>
                                                <ListItemIcon>
                                                <Icon icon='tabler:circle-filled' height={7} width={7} />
                                                </ListItemIcon>
                                                <ListItemText>
                                                Accepted formats: CSV, XLSX, PDF, DOC, JPEG, PNG, MP4
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem disablePadding>
                                                <ListItemIcon>
                                                <Icon icon='tabler:circle-filled' height={7} width={7} />
                                                </ListItemIcon>
                                                <ListItemText>
                                                Size limit: Video 100MB, Image 6MB, other files 2MB
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem disablePadding>
                                                <ListItemIcon>
                                                <Icon icon='tabler:circle-filled' height={7} width={7} />
                                                </ListItemIcon>
                                                <ListItemText>
                                                Only one (1) file can be uploaded at once
                                                </ListItemText>
                                            </ListItem>
                                            </List>
                                        </Box>
                                    </div>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                    {files.length ? (
                        <Fragment>
                            <List>{fileList}</List>
                        </Fragment>
                    ) : null}
                    </Grid>                  
                </Grid>
          </DialogContent>
          {/* <DialogActions sx={{ display: "flex", justifyContent: "space-between" , padding: '0.25rem 1.625rem 0.625rem !important'}} className="dialog-actions-dense">               
              <Box>
                  <Button variant='outlined' onClick={handleClose}>
                      Cancel
                  </Button>
              </Box>
               <Box>
                  <Button
                      variant='contained'
                      color='main'
                      disabled={btnLoader}
                      onClick={() => handleUpload()}
                  >
                      {btnLoader ? <CircularProgress size={24} /> : 'Upload'}
                  </Button>
              </Box>
          </DialogActions> */}
          <DialogActions
          sx={{ 
                display: "flex", 
                justifyContent: "space-between", 
                padding: '20px 24px !important', 
                boxShadow: `0px -4px 8px rgb(0, 0, 0, 0.1)`, 
                zIndex: 1 
            }}
          className="dialog-actions-dense"
        >
          <Box>
            <Button
              variant="contained"
              color="info"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
          <Box>
            <Button
                variant='contained'
                color='main'
                disabled={btnLoader}
                onClick={handleUpload}
            >
                {btnLoader ? <CircularProgress size={24} /> : 'Upload'}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
  );
};

export default PreAttachment;
